import { BoxProps, Flex, Text, useTheme } from '@chakra-ui/react';
import { rgba } from 'polished';
import React from 'react';
import { rem } from 'utils/fonts';

const InfoText: React.FC<BoxProps> = ({ children, ...props }) => {
  const { colors } = useTheme();
  return (
    <Flex direction="row" color={rgba(colors.gray[900], 0.5)} {...props}>
      <Text fontSize={rem('13px')}>{children}</Text>
    </Flex>
  );
};

export default InfoText;
